import { useEffect } from "react";
import {
  Redirect,
  Route,
  Switch,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { checkoutActions } from "../../redux/checkout/checkout.reducer";
import { selectStripePK } from "../../redux/checkout/checkout.selectors";

import CheckoutFooter from "../../components/checkout-footer";
import CheckoutCartPage from "../../pages/checkout-cart";
import CheckoutInfoPage from "../../pages/checkout-info";
import CheckoutPaymentPage from "../../pages/checkout-payment";
import CheckoutShippingPage from "../../pages/checkout-shipping";
import CheckoutConfirmPage from "../../pages/checkout-confirm";

const checkoutRoutes = ["cart", "information", "shipping", "payment"];

const CheckoutRoutes = () => {
  const dispatch = useDispatch();

  const { path } = useRouteMatch();
  const { checkoutProcessPath }: { checkoutProcessPath: string } = useParams();

  const stripePK = useSelector(selectStripePK);

  let stripePromise: any;

  if (stripePK) {
    stripePromise = loadStripe(stripePK);
  }

  useEffect(() => {
    if (!stripePK) {
      dispatch({ type: checkoutActions.getStripePKStart.type });
    }
  }, []);

  const currentProcess = () => {
    switch (checkoutProcessPath) {
      case "cart":
        return <CheckoutCartPage />;
      case "information":
        return <CheckoutInfoPage checkoutRoutes={checkoutRoutes} />;
      case "shipping":
        return <CheckoutShippingPage checkoutRoutes={checkoutRoutes} />;
      case "payment":
        return (
          <Elements stripe={stripePromise}>
            <CheckoutPaymentPage checkoutRoutes={checkoutRoutes} />
          </Elements>
        );
      case "confirmation":
        return <CheckoutConfirmPage />;
      default:
        return <Redirect to="/checkout/cart" />;
    }
  };

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "3rem auto",
      }}
    >
      <Switch>
        <Route exact path={`${path}`}>
          {currentProcess}
        </Route>
      </Switch>
      <CheckoutFooter />
    </div>
  );
};

export default CheckoutRoutes;
